import {
    clickPracticeName,
    trackClickProfessionalStatementShowMore,
    trackClickIBubbleBoardCertifications,
    trackClickIBubbleHospitalAffiliations,
    trackClickIBubbleInsuranceAccepted,
    trackClickIBubbleLanguage,
    trackClickIBubbleNpi,
    trackClickIBubblePracticeNames,
    trackClickIBubbleSpecialty,
    trackClickIBubbleProviderGender,
    trackClickRapidRegistration,
    trackClickSeeYouAgain,
    trackClickSpeedyResponse,
    trackClickSchedulingHero,
    trackClickDataProvidedBy,
} from './actions';

export default {
    clickPracticeName,
    trackClickProfessionalStatementShowMore,
    trackClickIBubbleBoardCertifications,
    trackClickIBubbleHospitalAffiliations,
    trackClickIBubbleInsuranceAccepted,
    trackClickIBubbleLanguage,
    trackClickIBubbleNpi,
    trackClickIBubblePracticeNames,
    trackClickIBubbleSpecialty,
    trackClickIBubbleProviderGender,
    trackClickRapidRegistration,
    trackClickSeeYouAgain,
    trackClickSpeedyResponse,
    trackClickSchedulingHero,
    trackClickDataProvidedBy,
};
